import { apiUri } from '../appConfig';
import handleErrorRequest from './handleErrorRequest';

/**
 * remember to catch error, like room-info.js
 */
const roomDetail = (id) => (
	fetch(`${apiUri}/room/${id}`)
		.then((res) => handleErrorRequest(res))
);

export default roomDetail;



// WEBPACK FOOTER //
// ./src/js/request/roomDetail.js